/**
 * @file Manages the methods of the HomeScreen screen.
 */

import React, { useContext } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { Loader } from '@domoscio/domoscio-ui'
import { useDomToolkit } from '../styles/dom-toolkit'
import { useLearningDatas } from '../hooks/useLearningDatas'
import { useRestrictAccess } from '../hooks/access/useRestrictAccess'
import { useRiseUpClient } from '../hooks/useRiseUpClient'
import { redirect } from '../components/Errors'
import { User } from '../contexts/parameters'

const parentRoute = (url: string) => {
  const [parent] = url.split('/').slice(1)
  return url === '/' ? null : parent
}

/**
 * Renders the Home Screen
 *
 * @category Screens
 */
function HomeScreen() {
  // 1. Initialize classes & states
  const classes: any = useDomToolkit()

  // 2. Initialize route information
  const location = useLocation()
  const parent = parentRoute(location?.pathname)
  const params = useParams()
  const user = useContext(User.State)

  // 3. Fetch student learning datas
  const { loading } = useLearningDatas(true, parent)
  const { isRiseup } = useRiseUpClient()
  const isPreprod = process.env.REACT_APP_DOMOSCIO_ENV === 'preprod'

  // 4. Verify that :id params is inside LearningContext
  useRestrictAccess(loading, parent)

  // If data are not ready, continue loading
  if (loading) {
    return <Loader />
  }

  if (isRiseup && !params.id && isPreprod) {
    redirect('riseup-no-ls', undefined, undefined, user?.uid)
  }

  return (
    <div
      className={`HomeScreen ${classes.domHeight100} ${classes.domFlex} ${classes.domFlexColumn} ${isRiseup ? 'frameLayout' : ''}`}
    >
      <div className={`${classes.domMarginTop} ${classes.domFlex1}`}>
        <Outlet />
      </div>
    </div>
  )
}

export default HomeScreen
